import React from "react";
import Downshift from "downshift";

export const stateReducer = (state, changes) => {
  switch (changes.type) {
    case Downshift.stateChangeTypes.keyDownEnter:
    case Downshift.stateChangeTypes.clickItem:
      return {
        ...changes,
        inputValue: "",
        isOpen: true,
        highlightedIndex: state.highlightedIndex
      };
    default:
      return changes;
  }
};

class MultiDownshift extends React.Component {
  state = { selectedItems: [] };

  removeItem = (item, cb) => {
    this.setState(
      ({ selectedItems }) => ({
        selectedItems: selectedItems.filter(x => x !== item)
      }),
      cb
    );
  };

  addItem = (item, cb) => {
    this.setState(
      ({ selectedItems }) => ({ selectedItems: [...selectedItems, item] }),
      cb
    );
  };

  setSelectedItems = (selectedItems, cb) => {
    this.setState({ selectedItems }, cb);
  };

  getStateAndHelpers = downshift => {
    const { addItem, removeItem, setSelectedItems } = this;
    const { selectedItems } = this.state;
    return {
      ...downshift,
      addItem,
      removeItem,
      selectedItems,
      setSelectedItems
    };
  };

  handleSelection = (selectedItem, downshift) => {
    const callOnChange = () => {
      const { onChange, onSelect } = this.props;
      onSelect && onSelect(selectedItem, this.getStateAndHelpers(downshift));
      onChange && onChange(selectedItem, this.getStateAndHelpers(downshift));
    };

    if (this.state.selectedItems.includes(selectedItem)) {
      this.removeItem(selectedItem, callOnChange);
    } else {
      this.addItem(selectedItem, callOnChange);
    }
  };

  render() {
    const { children, ...rest } = this.props;
    const aStateReducer = this.props.stateReducer || stateReducer;

    return (
      <Downshift
        {...rest}
        selectedItem={null}
        onChange={this.handleSelection}
        stateReducer={aStateReducer}
      >
        {downshift => children(this.getStateAndHelpers(downshift))}
      </Downshift>
    );
  }
}

export default MultiDownshift;
